<template>
<v-app>
    <eps-login-header></eps-login-header>
    <v-content>
        <v-container class="fill-height" fluid>

        </v-container>

    </v-content>
    <eps-login-footer></eps-login-footer>
</v-app>
</template>

    
<script>
import axios from "axios";
import epsLoginHeader from "../LoginHeader.vue";
import epsLoginFooter from "../LoginFooter.vue";
import CryptoJS from "crypto-js";
export default {
    components: {
        epsLoginHeader: epsLoginHeader,
        epsLoginFooter: epsLoginFooter,
    },
    data() {
        return {
            app_link: true,
            ios_link: null,
            android_link: null,
            disabled: 0,
            value: String,
            value1: String,
            value2: String,
            error: false,
            hideen: true,
            error1: false,
            error_message: "",
            error_message1: "",
            user_1: {
                uid: "",
                oldpassword: "",
                password: "",
            },
            user: {
                uid: "",
                pass: "",
            },
            value: String,
            message: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            load: false,
            dialog: false,
            read_policy_load: false,
            trust_logo: null,
            hide_parent_sign_up: false,
            hide_forget_pswd: false,
            update_password_dialog: false,
            rules: {
                required: (value) => !!value || "Required.",
                uid: (value) => {
                    const pattern =
                        // /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            },
        };
    },
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        signIn() {
            localStorage.setItem("Temp", this.user.uid);
            if (this.perormLoginFormValidation()) {
                this.user.dns = window.location.hostname;
                axios
                    .post("/login/process", this.user)
                    .then((res) => {
                        console.log("API Response:", res.data); // Debugging line to check response

                        localStorage.setItem("EPS-bypassed-by", "");

                        if (res.data.msg === "200") {
                            localStorage.setItem("awspath", res.data.awspath);
                            localStorage.setItem("EPS-token", res.data.token);
                            localStorage.setItem("EPS-tenant", res.data.tenant);
                            localStorage.setItem("EPS-uid", res.data.uid);
                            localStorage.setItem("EPS-org-id", res.data.orgid);
                            localStorage.setItem("EPS-ut", res.data.ut);
                            localStorage.setItem("EPS-org-name", res.data.org_name);
                            localStorage.setItem("EPS-org-domain-id", res.data.org_domain_id);
                            localStorage.setItem("username", res.data.username);
                            localStorage.setItem(
                                "profile_image_path",
                                res.data.profile_image_path
                            );
                            localStorage.setItem(
                                "profile_image_name",
                                res.data.profile_image_name
                            );
                            localStorage.setItem(
                                "report-field",
                                JSON.stringify(res.data.rep_fields)
                            );
                            if (res.data.payment_due_date) {
                                localStorage.setItem(
                                    "payment_due_date",
                                    res.data.payment_due_date
                                );
                            }
                            this.$session.start();

                            if (res.data.policy_read) {
                                this.$router.push("/home");
                            } else {
                                this.dialog = true;
                            }
                        } else if (res.data.flag === "No") {
                            //alert("res.data.change_password" + res.data.change_password)
                            if (res.data.change_password && res.data.change_password == true) {
                                this.showSnackbar(
                                    "#C62828",
                                    "Username And Password Cannot Be The Same... Please Change Your Password!"
                                );
                                this.update_password_dialog = true;
                            } else {
                                console.log("Payment due date flag detected"); // Debugging line
                                this.showSnackbar("#C62828", res.data.snackbar || "Your payment is overdue.");
                                return;
                            }
                        } else if (res.data.msg === "blocked") {
                            this.showSnackbar("#C62828", "This User Is Blocked!");
                            this.clearLocalStorage();
                        } else {
                            console.log("Unknown response, falling to default case"); // Debugging line
                            this.showSnackbar("#C62828", "Please Check Your Credentials!");
                            this.clearLocalStorage();
                        }
                    })
                    .catch((error) => {
                        console.error("Login error:", error);
                        this.showSnackbar("#C62828", "Something Went Wrong!");
                    });
            } else {
                console.log("I am in else block");
            }
        },
        clearLocalStorage() {
            localStorage.setItem("EPS-token", "");
            localStorage.setItem("EPS-uid", "");
            localStorage.setItem("EPS-ut", "");
            localStorage.setItem("EPS-tenant", "");
            localStorage.setItem("EPS-org-name", "");
            localStorage.setItem("username", "");
            localStorage.setItem("profile_image_path", "");
            localStorage.setItem("profile_image_name", "");
        },
        clear() {
            this.user.uid = "";
            this.user.pass = "";
        },
        perormLoginFormValidation() {
            if (this.user.uid == "" && this.user.pass == "") {
                return false;
            } else {
                return true;
            }
        },
    },
    created() {
        this.trust_logo = localStorage.getItem("EPS-trust-logo");
    },
    mounted() {
        //alert("hello000000")
        const secretKey = process.env.VUE_APP_API_PARAMS_KEY;; // Same key used for encryption

        // Retrieve query parameters
        const encryptedUID = this.$route.query.uid;
        const encryptedPassword = this.$route.query.password;

        if (encryptedUID && encryptedPassword) {
            // Decrypt the values
            const decryptedUID = CryptoJS.AES.decrypt(decodeURIComponent(encryptedUID), secretKey).toString(CryptoJS.enc.Utf8);
            const decryptedPassword = CryptoJS.AES.decrypt(decodeURIComponent(encryptedPassword), secretKey).toString(CryptoJS.enc.Utf8);

            this.user.uid = decryptedUID;
            this.user.pass = decryptedPassword;

            //alert("uid--"+uid)
            //alert("password--"+password)
            localStorage.setItem("Temp", this.user.uid);
            if (this.perormLoginFormValidation()) {
                this.user.dns = window.location.hostname;
                axios
                    .post("/login/process", this.user)
                    .then((res) => {
                        localStorage.setItem("EPS-bypassed-by", "");
                        if (res.data.msg === "200") {
                            localStorage.setItem("awspath", res.data.awspath);
                            localStorage.setItem("EPS-token", res.data.token);
                            localStorage.setItem("EPS-tenant", res.data.tenant);
                            localStorage.setItem("EPS-uid", res.data.uid);
                            localStorage.setItem("EPS-org-id", res.data.orgid);
                            localStorage.setItem("EPS-ut", res.data.ut);
                            localStorage.setItem("EPS-org-name", res.data.org_name);
                            localStorage.setItem("EPS-org-domain-id", res.data.org_domain_id);
                            localStorage.setItem("username", res.data.username);
                            localStorage.setItem(
                                "profile_image_path",
                                res.data.profile_image_path
                            );
                            localStorage.setItem(
                                "profile_image_name",
                                res.data.profile_image_name
                            );
                            localStorage.setItem(
                                "report-field",
                                JSON.stringify(res.data.rep_fields)
                            );
                            if (res.data.payment_due_date) {
                                localStorage.setItem(
                                    "payment_due_date",
                                    res.data.payment_due_date
                                );
                            }
                            this.$session.start();

                            if (res.data.policy_read) {
                                this.$router.push("/home");
                            } else {
                                this.dialog = true;
                            }
                        } else if (res.data.flag === "No") {
                            //alert("res.data.change_password" + res.data.change_password)
                            if (res.data.change_password && res.data.change_password == true) {
                                this.showSnackbar(
                                    "#C62828",
                                    "Username And Password Cannot Be The Same... Please Change Your Password!"
                                );
                                this.update_password_dialog = true;
                            } else {
                                console.log("Payment due date flag detected"); // Debugging line
                                this.showSnackbar("#C62828", res.data.snackbar || "Your payment is overdue.");
                                return;
                            }
                        } else if (res.data.msg === "blocked") {
                            this.showSnackbar("#C62828", "This User Is Blocked!");
                            this.clearLocalStorage();
                        } else {
                            console.log("Unknown response, falling to default case"); // Debugging line
                            this.showSnackbar("#C62828", "Please Check Your Credentials!");
                            this.clearLocalStorage();
                        }
                    })
                    .catch((error) => {
                        console.error("Login error:", error);
                        this.showSnackbar("#C62828", "Something Went Wrong!");
                    });
            } else {
                console.log("I am in else block");
            }
        }

    },
};
</script>

    
<style scoped>
.pull-right {
    position: relative;
    text-align: center;
}

.app {
    background: #9575DE;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #9575DE,
            #9575DE,
            #9575DE);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #9575DE,
            #9575DE,
            #9575DE);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.button {
    border: 2px solid #025464 !important;
    color: #025464;
    background: transparent !important;
    border-radius: 50px;
    margin: 0.5rem !important;
}

.button:hover {
    color: white;
    background: #025464 !important;
    background: #025464;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #025464,
            #025464,
            #025464);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #025464,
            #025464,
            #025464);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.trust-logo {
    width: 250px;
    height: 155px;
}

.login-col {
    margin-left: 4%;
}

@media (max-width: 920px) {
    body {
        overflow-x: hidden;
        /* width: 100%; */
    }

    .login-col {
        margin-left: 1%;
    }
}
</style>
